// ErrorModal.js
import React from 'react';
import './ErrorModal.css'; // You can create a CSS file for styling

const ErrorModal = ({ isOpen, onClose, errorMessage }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="error-modal-overlay">
            <div className="error-modal">
                <div className="error-modal-header">
                    <h2 className="error-modal-title">Validation Errors</h2>
                    <button className="error-modal-close-icon" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="error-modal-content">
                    <pre className="error-modal-message">{errorMessage}</pre>
                </div>
                <div className="error-modal-actions">
                    <button className="error-modal-close-button" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorModal;